// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"805":"c2bff2d0271b75d4","915":"61b1afca5db6ce63"}[chunkId] + ".js";
};